<template><Toast />
	<div class="layout-topbar" >
		<router-link to="/" class="layout-topbar-logo">
			<img alt="Logo" :src="topbarImage()" />
			<span style="color: white;">City Hoardings</span>
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', 
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-calendar"></i>
					<span>Events</span>
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-cog"></i>
					<span>Settings</span>
				</button>
			</li>&nbsp;
			<li style="color: white;">
				{{ full_name }}<br>( {{ user_role_name }}	)
			</li>
			<li>
				<button class="p-link layout-topbar-button" @click="toggleMenu">	
						<i class="pi pi-user"></i><br>
					<span >Profile </span>
					<Menu ref="menu" :model="overlayMenuItems" :popup="true" />
					
				</button>
				<!-- <br>{{name}} -->
				
			</li>
		</ul>
	</div>

	<Dialog
          v-model:visible="productDialog"
          :style="{ width: '450px', width: '450px' }"
		  
          header="Change Password"
          :modal="true"
          class="p-fluid"
        >
		<loading
    :active="isLoadingModel"
    :can-cancel="true"
    
    color="#803BB9"
    :is-full-page="fullPage"
  ></loading>

		 				<label for="password1" class="block text-900 font-medium text-xl mb-2">Old Password</label>
                        <Password id="password1" v-model="password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 <label for="password1" class="block text-900 font-medium text-xl mb-2">New Password</label>
                        <Password id="password1" v-model="new_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 <label for="password1" class="block text-900 font-medium text-xl mb-2">Confirm Password</label>
                        <Password id="password1" v-model="conf_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						<Button label="Change Password" class="p-button-rounded p-button-success" @click="change()" />
		</Dialog>
</template>

<script>
import apis from "@/apis";
export default {
	data() {
		
			return {
				id:"",
				conf_password: "",
				new_password: "",
				password: "",
				productDialog:false,
				user_role_name:"",
				full_name:"",
				name:"",
				isLoadingModel: false,
				overlayMenuItems: [
					{
						label: 'My Profile',
						icon: 'pi pi-save',
						to:'/profile'
					},
					{
						label: 'Change Password',
						icon: 'pi pi-pencil',
						command: () => {
							this.conf_password= "";
							this.new_password= "";
							this.password= "";
							this.productDialog = true;
							
          }
					},
					{
						label: 'Logout',
						icon: 'pi pi-sign-in',
						to:'/',
						// click: () => {
							command: () => {
						//	this.$session.destroy();
      				localStorage.clear();
      				this.$router.push("/");
            	return false;
          }
					},
					
				],
			}
	},
    methods: {
		change()
		{
			const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
			
			 if (!this.password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Old password",
          life: 3000,
        });
        return false;
      }
	   if (!this.new_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter New password",
          life: 3000,
        });
        return false;
      }
				if (!passwordPattern.test(this.new_password)) {
				this.$toast.add({
				severity: "error",
				summary: "Error",
				detail: "New Password must contain at least 8 characters, one uppercase, one lowercase, and one special character.",
				life: 3000,
				});
				return false;
			}
	   if (!this.conf_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Confirm password",
          life: 3000,
        });
        return false;
      }
	  if (this.conf_password != this.new_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Confirm Password Not Match With New Password",
          life: 3000,
        });
        return false;
      }
	  var uname="";
	  if (localStorage.getItem("user_key")=='student') 
	  {
		uname=localStorage.getItem('mobile');
	  }
	  else
	  {
		uname=localStorage.getItem('email');
	  }

		//api
      	var data = {
        id: localStorage.getItem('id'),
        old_password: this.password,
		new_password:this.new_password,
        // type: localStorage.getItem('user_key'),
	
      };
	
    
    //   var promise = apis.passwordreset(data, this.id);
    //   promise.then((response) => {
     
	// 		this.productDialog = false;
    //     	this.$swal(response.data.message);
    //     	this.update_pass_Dialog = false;
	// 	 	localStorage.clear();
      	 
    //   }).catch((error) => {
          
    //       	this.productDialog = false;
	// 		this.$swal.fire(error.response.data);
         
    //       });

	//New

// 	var promise = apis.passwordreset(data, this.id);
// promise.then((response) => {
// 	this.isLoadingModel = false;
  
//     this.productDialog = false;
    
   
//     this.$swal(response.data.message);
    
    
//     if (response.data.status) {
     
//         this.$router.push("/");
//         this.update_pass_Dialog = false;
	
//         localStorage.clear();
//     } else {
       
//         this.$swal.fire("Error", response.data.message, "error"); 
		
//     }
// 			}).catch((error) => {
// 				 this.productDialog = false;
			
// 				this.$swal.fire("Error", error.response.data.message || "An error occurred", "error");
// 			});

this.isLoadingModel = true; 

var promise = apis.passwordreset(data, this.id);
promise.then((response) => {
    this.isLoadingModel = false; 

  
    if (response.data.status) {
        this.productDialog = false;
        this.update_pass_Dialog = false;
        this.$swal(response.data.message);
        this.$router.push("/"); 
        localStorage.clear();
    } else {
      
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: response.data.message,
          life: 3000,
        });
    }
}).catch((error) => {
    this.isLoadingModel = false; 
    this.productDialog = true; 
    this.$swal.fire("Error", error.response.data.message || "An error occurred", "error");
});

		
			


		
			
		},
			toggleMenu(event) {
				this.$refs.menu.toggle(event);
			},
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
		topbarImage() {
			return this.$appState.darkTheme ? 'images/logon.png' : 'images/logon.png';
		}
    },

		mounted(){
			this.name= localStorage.getItem("email");
			this.full_name = localStorage.getItem('full_name');
			this.user_role_name = localStorage.getItem('user_role_name');
		},
		
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	}
}
</script>
<style scoped>
.layout-topbar .layout-topbar-logo {
   
    width: 200px;
   
}
.p-fluid {
  position: absolute;
  left: 45px;
  top: 55px;
  z-index: 9999;
}
</style>